import { randomOutfit } from '../art/charArt';
/**
 * Stress-test NPCs: each one idles for a while, picks a random walkable
 * tile within `radius`, asks the scene for a path (queued under the per-tick
 * path budget) and walks there. Game-side logic only; the engine just moves
 * characters where it is told.
 */
export class Wanderers {
    scene;
    r;
    radius;
    npcs = [];
    idleUntil = new Map();
    time = 0;
    constructor(scene, r, radius = 14) {
        this.scene = scene;
        this.r = r;
        this.radius = radius;
    }
    spawn(count) {
        const g = this.scene.grid;
        let guard = 0;
        while (this.npcs.length < count && guard++ < count * 50) {
            const x = Math.floor(this.r() * g.width);
            const y = Math.floor(this.r() * g.height);
            if (!g.isWalkable(x, y))
                continue;
            const ch = this.scene.addCharacter({ x, y, outfit: randomOutfit(this.r), speed: 1.6 + this.r() * 0.9 }); // NPCs stroll a bit slower than players
            ch.onArrive = (c) => this.idleUntil.set(c, this.time + 0.5 + this.r() * 3.5);
            this.idleUntil.set(ch, this.time + this.r() * 2);
            this.npcs.push(ch);
        }
    }
    /** Sim tick. */
    update(dt) {
        this.time += dt;
        const g = this.scene.grid;
        for (const ch of this.npcs) {
            if (ch.goal || ch.pathPending || ch.mover.moving)
                continue;
            const until = this.idleUntil.get(ch) ?? 0;
            if (this.time < until)
                continue;
            for (let tries = 0; tries < 8; tries++) {
                const x = ch.mover.tileX + Math.round((this.r() * 2 - 1) * this.radius);
                const y = ch.mover.tileY + Math.round((this.r() * 2 - 1) * this.radius);
                if (g.isWalkable(x, y)) {
                    this.scene.moveTo(ch, x, y);
                    break;
                }
            }
            this.idleUntil.set(ch, this.time + 1);
        }
    }
}
